import { API } from "../../App";

export const contractorPhotoUrl = (token, defectId, photoId, thumb = true) =>
  `${API}/public/contractor-defects/${token}/${defectId}/photos/${photoId}${thumb ? "?thumb=true" : ""}`;

export const managerPhotoUrl = (defectId, photoId, thumb = true) =>
  `${API}/defects/${defectId}/completion-photos/${photoId}${thumb ? "?thumb=true" : ""}`;

export async function uploadCompletionPhotos(url, files, headers = {}) {
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f));
  const res = await fetch(url, { method: "POST", headers, body: fd });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Upload failed");
  return data;
}

export async function deleteCompletionPhoto(url, headers = {}) {
  const res = await fetch(url, { method: "DELETE", headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Could not remove photo");
  return data;
}
